export default __webpack_public_path__ + "static/media/Clock.33729344.webp";